import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LocizeBackend from "i18next-locize-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import LastUsed, { LocizeLastusedOptions } from "locize-lastused";

const isDev = import.meta.env.MODE === "development";

if (isDev) {
  i18n.use(LastUsed);
}

const locizeOptions = {
  projectId: import.meta.env.VITE_LOCIZE_PROJECT_ID,
  apiKey: import.meta.env.VITE_LOCIZE_API_KEY,
  version: import.meta.env.VITE_LOCIZE_VERSION,
  referenceLng: "en",
};

i18n
  .use(LocizeBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init<LocizeLastusedOptions>({
    fallbackLng: "en",
    debug: isDev,
    saveMissing: isDev,
    supportedLngs: ["en", "es", "pt"],
    backend: locizeOptions,
    locizeLastUsed: locizeOptions,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
